import { GlLoadingIcon, GlTooltipDirective, GlBadge } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import { s__ } from '~/locale';
import TimeAgoTooltip from '/builds/gitlab/gitlab-ee/app/assets/javascripts/vue_shared/components/time_ago_tooltip.vue?vue3';
import { getIdFromGid } from '../utils';
export default {
    name: 'NoteHeader',
    components: {
        GlLoadingIcon,
        TimeAgoTooltip,
        GlBadge
    },
    directives: {
        GlTooltip: GlTooltipDirective
    },
    props: {
        author: {
            type: Object,
            required: false,
            default: ()=>({})
        },
        createdAt: {
            type: String,
            required: false,
            default: null
        },
        showSpinner: {
            type: Boolean,
            required: false,
            default: false
        },
        isInternalNote: {
            type: Boolean,
            required: false,
            default: false
        },
        emailParticipant: {
            type: String,
            required: false,
            default: ''
        },
        noteId: {
            type: String,
            required: false,
            default: ''
        }
    },
    data () {
        return {
            isUsernameLinkHovered: false
        };
    },
    computed: {
        authorId () {
            return getIdFromGid(this.author?.id);
        },
        authorHref () {
            const { author } = this;
            return author.path || author.webUrl;
        },
        authorName () {
            return this.isServiceDeskEmailParticipant ? this.emailParticipant : this.author.name;
        },
        isServiceDeskEmailParticipant () {
            return !this.isInternalNote && this.author.username === 'support-bot' && this.emailParticipant;
        },
        internalNoteTooltip () {
            return s__('Notes|This internal note will always remain confidential');
        },
        dynamicClasses () {
            return {
                authorLink: {
                    hover: this.isUsernameLinkHovered,
                    'text-underline': this.isUsernameLinkHovered
                }
            };
        },
        noteTimestampLink () {
            if (this.noteId) {
                return `#note_${this.noteId}`;
            }
            return undefined;
        }
    },
    methods: {
        handleUsernameMouseEnter () {
            this.isUsernameLinkHovered = true;
        },
        handleUsernameMouseLeave () {
            this.isUsernameLinkHovered = false;
        }
    }
};
